import Svg, { Rect } from 'react-native-svg';
import { withDefaultIconProps } from './index';
import { createTheme as createDSTheme } from 'app/shopify';
const theme = createDSTheme();

export const CheckCircle2NotYet = withDefaultIconProps(
  {
    height: 32,
    width: 32,
    color: theme.colors['border.secondary'],
  },
  ({ color, ...rest }) => (
    <Svg {...rest} viewBox="0 0 32 32">
      <Rect fill={color} height="32" rx="16" width="32" />
    </Svg>
  ),
);
